import { createAction, props } from '@ngrx/store';

export const UpdateProperty = createAction(
  '[Customization] UpdateProperty',
  props<{ name: string; value: string }>()
);
export const SetCustomization = createAction(
  '[Customization] SetCustomization',
  props<{ customization: Record<string, string> }>()
);
export const SaveCustomizations = createAction(
  '[Customization] SaveCustomizations',
  props<{ customization: Array<{ name: string; value: string }> }>()
);
